import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import { FaDownload } from "react-icons/fa";

const ReportGenerate = ({ excelData, fileName }) => {

  // console.log("excelData")
  // console.log(excelData)

  if (!excelData) {
    console.error("Excel data is null or undefined.");
    return null; // Or return an error message or placeholder component
}
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";
  var wscols = [
    { wch: 15 },
    { wch: 50 },
    { wch: 75 },
    { wch: 20 },
    { wch: 75 },
  ];
  const addStyles = (workSheet) => {

    Object.entries(workSheet)
    .filter(([k, v]) => k.charAt(0) === "A")
    .forEach(([k, v]) => {
      if (v.v === "Year") {
        v.s = {
          fill: {
            fgColor: { rgb: "FFFFFF" },
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          font: {
            bold: false,
          }
        };
      } else {
        v.s = {
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          width: {
            auto: true,
          },
          height:{
            auto:true
          }       
        };
      }
    });

    Object.entries(workSheet)
    .filter(([k, v]) => k.charAt(0) === "B")
    .forEach(([k, v]) => {
      if (v.v === "VendorName") {
        v.v = "Vendor";
        v.s = {
          fill: {
            fgColor: { rgb: "D0D8e2" },
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText:true
          },
          font: {
            bold: true,
          }
         
        };
      }
      else{
        v.s = {
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          width: {
            auto: true,
          },
          height:{
            auto:true
          }
        };
      }
      
    });


    Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "C")
      .forEach(([k, v]) => {
        if (v.v === "High") {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "E3A9A9" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText:true
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

      Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "D")
      .forEach(([k, v]) => {
        if (
          v.v === "Work in Progress" ||
          v.v === "In-Progress" ||
          v.v === "Annual Reassessment In Progress"
        ) {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "4F66D3" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } 
        else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

    Object.entries(workSheet)
      .filter(([k, v]) => k.charAt(0) === "E")
      .forEach(([k, v]) => {
        if (v.v === "High") {
          v.s = {
            font: {
              sz: 12,
              color: { rgb: "FFFFFF" },
            },
            fill: {
              fgColor: { rgb: "E3A9A9" },
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
            },
           
          };
        } else {
          v.s = {
            font: {
              sz: 12,
            },
            alignment: {
              vertical: "center",
              horizontal: "center",
              wrapText:true
            },
            width: {
                auto: true,
              },
              height:{
                auto:true
              }
           
          };
        }
      });

  };

  const excelDataLength = excelData.length;
  const rowHeight = Array(excelDataLength)
    .fill()
    .map((item) => ({ hpt: 30 }));

  // console.log("rowHeight")
  //console.log(rowHeight,excelDataLength)

  const exportTOExcel = async () => {
    const transformedData = transformData(excelData); // Assuming your data is always an array with one object
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const range = ws["!ref"];
    ws["!autofilter"] = { ref: range };
    addStyles(ws);
    ws["!cols"] = wscols;
    ws["!rows"] = rowHeight;
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const exelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([exelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};


const transformData = (excelData) => {
  let newArray = [];
  for (const categoryKey in excelData) {
      if (Object.hasOwnProperty.call(excelData, categoryKey)) {
          const category = excelData[categoryKey];
          category.chats.forEach((chat, chatIndex) => {
              chat.XAxis.forEach((xAxisItem, xAxisIndex) => {
                  const yAxisValue = chat.YAxis[xAxisIndex] || 0; // default to 0 if YAxis value is not available
                  newArray.push({
                      Persona: category.name,
                      Report: xAxisItem,
                      Views: yAxisValue,
                  });
              });
          });
      }
  }
  return newArray;
};






  return (
    <div>
      <button
        style={{fontSize: "14px", padding: "12px",border:"none",width:"50px",borderRadius:"6px"}}
        onClick={(e) => exportTOExcel(fileName)}
        title="Export in excel"
      >
        <FaDownload/>
      </button>
    </div>
  );
};

export default ReportGenerate;
